import React from "react";
import { Card } from "react-bootstrap";
import { FiBriefcase, FiUsers, FiCalendar, FiFileText } from "react-icons/fi";

const stats = [
  {
    icon: <FiBriefcase />,
    value: "47",
    label: "Open Positions",
    bg: "#FFF1E8",
    color: "#F97316",
    border: "#FDBA74",
  },
  {
    icon: <FiUsers />,
    value: "2,384",
    label: "Total Candidates",
    bg: "#E6F4F4",
    color: "#0F766E",
    border: "#99D6D3",
  },
  {
    icon: <FiCalendar />,
    value: "12",
    label: "Interviews Today",
    bg: "#F5F5F5",
    color: "#374151",
    border: "#D1D5DB",
  },
  {
    icon: <FiFileText />,
    value: "28",
    label: "Offers Released",
    bg: "#EAF1FF",
    color: "#3B82F6",
    border: "#A5C4FF",
  },
];

export default function RecruitmentStatsCards() {
  return (
    <Card className="stats-card mt-3">
      <Card.Body className="p-2">
        <div className="stats-wrapper">
          {stats.map((item, i) => (
            <div className="stat-item" key={i}>
              
              {/* ICON BOX */}
              <div
                className="icon-box"
                style={{
                  background: item.bg,
                  border: `1px solid ${item.border}`,
                }}
              >
                {/* FORCE ICON COLOR (NO CSS CONFLICT) */}
                {React.cloneElement(item.icon, {
                  color: item.color,
                  size: 18,
                })}
              </div>

              <h4>{item.value}</h4>
              <span>{item.label}</span>

              {i !== stats.length - 1 && <div className="divider" />}
            </div>
          ))}
        </div>
      </Card.Body>

      {/* ================= STYLES ================= */}
      <style>{`

        .stats-card {
          border-radius: 6px;
          border: 1px solid #e5e7eb;
          background: #fff;
        }

        .stats-wrapper {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          text-align: center;
        }

        .stat-item {
          position: relative;
          padding: 16px 10px;
        }

        .icon-box {
          width: 44px;
          height: 44px;
          margin: 0 auto 8px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        h4 {
          margin: 4px 0 2px;
          font-size: 20px;
          font-weight: 700;
          color: #111827;
        }

        span {
          font-size: 13px;
          color: #6b7280;
        }

        .divider {
          position: absolute;
          right: 0;
          top: 25%;
          height: 50%;
          width: 1px;
          background: #e5e7eb;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .stats-wrapper {
            grid-template-columns: repeat(2, 1fr);
          }

          .divider {
            display: none;
          }

          h4 {
            font-size: 18px;
          }

          span {
            font-size: 12px;
          }
        }

      `}</style>
    </Card>
  );
}